'use strict';

const cssConstants = require('../utils/cssConstants');

const GENERIC_FALLBACK_MSG = 'Le service est momentanément indisponible. Merci de réessayer ultérieurement';

/**
 * Display error message.
 * @param {string} selector - selector of input field
 * @param {string} msg - error message
 */
function showError (selector, msg) {
    var safeMsg = (typeof msg === 'string' && msg.length) ? msg : GENERIC_FALLBACK_MSG;
    var $input = $(selector);
    var $formGroup = $input.closest('.form-group');
    $input.addClass('error');
    var $nextBlock = $input.next();
    if ($formGroup.length) {
        $input.addClass(cssConstants.INVALID);
        $formGroup.addClass(cssConstants.FORM_GROUP_INVALID);
        if ($input.val().length) {
            $input
                .closest('.js-field-container')
                .find('.invalid-feedback')
                .text(safeMsg);
        }
    } else if ($nextBlock.hasClass('error-message')) {
        $nextBlock
            .removeClass(cssConstants.HIDDEN)
            .text(safeMsg);
    } else {
        $input
            .after(`
                <div class="error-message">
                    ${safeMsg}
                </div>`
            );
    }
}

/**
 * Display error message.
 * @param {string} selector - selector of input field
 */
function hideError (selector) {
    var $input = $(selector);
    var $formGroup = $input.closest('.form-group');

    if ($formGroup.length) {
        $input.removeClass(cssConstants.INVALID);
        $formGroup.removeClass(cssConstants.FORM_GROUP_INVALID);
    } else {
        $input.removeClass('error');
        var $nextBlock = $input.next();
        if ($nextBlock.hasClass('error-message')) {
            $nextBlock.addClass(cssConstants.HIDDEN);
        }
    }
}

module.exports = {
    showError: showError,
    hideError: hideError,
    GENERIC_FALLBACK_MSG: GENERIC_FALLBACK_MSG
};
